import toolNames from '../toolNames';
import {
  FaArrowsAltH,
  FaGripLines,
  FaVectorSquare,
  FaRegCircle,
  FaEraser,
  FaPenNib,
  FaAngleRight,
  FaTrash,
} from '../../../../../util/reactIcons';
import { getVolumeManager } from '../../../Viewer/getVolumeManager';

export const annotationsOptions = [
    {
      label: 'toolbar.length',
      name: toolNames.LENGTH,
      icon: FaArrowsAltH,
      type: 'button',
      callback: undefined,
      keysPressed: { key: 's' },
    },
    {
      label: 'toolbar.angle',
      name: toolNames.ANGLE,
      icon: FaAngleRight,
      type: 'button',
      callback: undefined,
      keysPressed: { key: 'd' },
    },
    {
      label: 'toolbar.lines',
      name: toolNames.COBB_ANGLE,
      icon: FaGripLines,
      type: 'button',
      callback: undefined,
      keysPressed: { key: 'f' },
    },
    {
      label: 'toolbar.rectangle',
      name: toolNames.RECTANGLE_ROI,
      icon: FaVectorSquare,
      type: 'button',
      callback: undefined,
      keysPressed: { key: 'g' },
    },
    {
      label: 'toolbar.circle',
      name: toolNames.ELLIPTICAL_ROI,
      icon: FaRegCircle,
      type: 'button',
      callback: undefined,
      keysPressed: { key: 'j' },
    },
    {
      label: 'toolbar.freehandroi',
      name: toolNames.FREEHAND_ROI,
      icon: FaPenNib,
      type: 'button', // dropdown
      callback: undefined,
      keysPressed: { key: 'k' },
    },
    {
      label: 'toolbar.eraser',
      name: toolNames.ERASER,
      icon: FaEraser,
      type: 'button',
      callback: undefined,
      keysPressed: { key: 'l' },
    },
  ];

const mprAnnotationNames = {
  [toolNames.LENGTH]: 'rule',
  [toolNames.ANGLE]: 'angle',
  [toolNames.COBB_ANGLE]: 'cobbAngle',
  [toolNames.RECTANGLE_ROI]: 'rectangle',
  [toolNames.ELLIPTICAL_ROI]: 'ellipse',
  [toolNames.FREEHAND_ROI]: 'freeHand',
};

export const mprAnnotationsOptions = annotationsOptions
  .filter(({ name }) => mprAnnotationNames[name])
  .map((option) => ({
    ...option,
    mprAnnotationName: mprAnnotationNames[option.name],
  }))
  .concat({
    label: () => (getVolumeManager()?.areAnnotationsSelected()
      ? 'toolbar.eraseSelectedAnnotations'
      : 'toolbar.eraser'),
    name: toolNames.ERASER,
    icon: FaEraser,
    type: 'button',
    disabled: () => {
      const viewManager = getVolumeManager();
      return !viewManager?.areAnnotationsSelected() && !viewManager?.annotations?.length;
    },
  })
  .concat({
    label: 'toolbar.clearAnnotations',
    name: toolNames.CLEAR_ANNOTATIONS,
    icon: FaTrash,
    type: 'button',
    disabled: () => !getVolumeManager()?.annotations?.length,
  });
